module.exports = __webpack_public_path__ + "img/xtsz.a2d3e42b.svg";